export enum Language {
    English = "en",
    French = "fr",
    Spanish = "es",
    German = "de",
    Italian = "it",
    Japanese = "ja",
    Russian = "ru",
    Czech = "cs",
    Polish = "pl"
}
